import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'safeImageUrl',
    standalone: false
})
export class SafeImageUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  //used in organization branding images to bypass sanitization of image url
  transform(value: string, ...args: unknown[]): unknown {
    return this.sanitizer.bypassSecurityTrustUrl(value);
  }

}
